// import { LanguagesEnum } from "@monorepo/types";

const getLanguage = () => {
  if (
    window?.location?.protocol === "https:" &&
    (window?.location?.hostname?.slice(-3) === ".pl" || window?.location?.hostname?.startsWith("pl"))
  ) {
    return "pl";
  }
  return "lt";
};

export const LANGUAGE = getLanguage();
// export const LANGUAGE = "lt" as LanguagesEnum;
